import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useCognitoAuthContext } from '@caplend/cognito-auth';
import HansePayLoader from '../HansePayLoader';

function AccessTokenOutlet() {
  const { hasAccessToken, isCheckingSession } = useCognitoAuthContext();
  const location = useLocation();

  if (isCheckingSession === true) {
    return <HansePayLoader variant='splash' />;
  }
  return hasAccessToken ? <Outlet /> : <Navigate to='/login' state={{ from: location }} replace />;
}

export default AccessTokenOutlet;
